<template>
  <div class="w-full">
    <div>
      <vs-row vs-w="12" vs-align="flex-start" vs-justify="center">
        <vs-col vs-w="12" vs-align="center" vs-justify="center">
          <div :id="uniqueId" class="vs-con-loading__container">
            <div id="simple-calendar-app" style="margin-left: -15px;">
            <div class="vx-card no-scroll-content">
              <calendar-view
                ref="calendar"
                :displayPeriodUom="calendarView"
                :show-date="showDate"
                :events="calendarEvents"
                enableDragDrop
                eventBorderHeight="0px"
                eventContentHeight="1.5rem"
                class="theme-default"
                :starting-day-of-week="1"
                @click-date="select"
              >
                <div slot="header" class="mb-4">
                  <div class="flex items-center justify-between w-full">
                    <!-- Left: Month navigation -->
                    <div class="flex items-center">
                      <feather-icon
                        :icon="
                          $vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'
                        "
                        @click="updateMonth(-1)"
                        svgClasses="w-5 h-5 m-1"
                        class="cursor-pointer bg-primary text-white rounded-full flex-shrink-0"
                      />

                      <span
                        @click="isModalMonthYearActive = true"
                        class="mx-3 text-xl font-medium whitespace-no-wrap text-center cursor-pointer hover:text-primary"
                        style="min-width: 160px; display: inline-block;"
                      >
                        {{ showDate | moment("MMM - YYYY") }}
                      </span>

                      <feather-icon
                        :icon="
                          $vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'
                        "
                        @click="updateMonth(1)"
                        svgClasses="w-5 h-5 m-1"
                        class="cursor-pointer bg-primary text-white rounded-full flex-shrink-0"
                      />
                    </div>

                    <!-- Right: Switch + Refresh button -->
                    <div class="flex flex-col items-center justify-center">
                      <div class="flex items-center mb-2">
                        <span class="mr-2 text-sm font-semibold">{{ mostrarHorasIniciais ? 'Horas Iniciais' : 'Manutenção' }}</span>
                        <vs-switch v-model="mostrarHorasIniciais" />
                      </div>
                      <vs-button size="small" class="w-full justify-center" color="primary" type="border" icon="refresh" @click="fetchForcaMensal">Atualizar</vs-button>
                    </div>
                  </div>
                </div>
              </calendar-view>
            </div>
          </div>
          </div>
        </vs-col>
      </vs-row>
      <component v-bind:is="showModalForca" :key="reRenderModal" :data="dia" :forcaDataObj="forcaDataObjSelecionada">
      </component>
      <ModalSelectMonthYear
        :active.sync="isModalMonthYearActive"
        :initial-month="showDate.getMonth()"
        :initial-year="showDate.getFullYear()"
        @selected="onMonthYearSelected"
      />
    </div>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from "@/store/calendar/moduleCalendar.js"
import modalForca from "./modalForca.vue"
import ModalSelectMonthYear from "@/components/default/ModalSelectMonthYear.vue"

require("vue-simple-calendar/static/css/default.css")

import Datepicker from "vuejs-datepicker"

export default {
  props: {
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    modalForca,
    ModalSelectMonthYear,
  },
  data () {
    return {
      showModalForca: null,
      showCardForca: null,
      reRenderModal: 0,
      reRenderCard: 0,
      forcaTurnos: null,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      calendarView: "month",
      dia: new Date(),
      mensalData: null,
      mostrarHorasIniciais: true,
      forcaDataObjSelecionada: null,
      uniqueId: 'calendar-loading-' + Math.random().toString(36).substr(2, 9),
      isModalMonthYearActive: false,
    }
  },
  computed: {
    calendarEvents() {
      if (!this.mensalData) return [];
      let events = [];
      for (const [date, turnos] of Object.entries(this.mensalData)) {
        if (turnos === "feriado") {
          events.push({
            startDate: date,
            title: "FERIADO",
            classes: "event-feriado"
          });
          continue;
        }
        const turnosInteresse = {
          "Manha": "M",
          "Tarde": "T",
          "Noite": "N"
        };
        for (const turno of turnos) {
          if (turnosInteresse[turno.nome]) {
            let val = this.mostrarHorasIniciais ? turno.forcaInicial : turno.forca;
            let bgClass = val > 0 ? "event-positive" : "event-negative";
            events.push({
              startDate: date,
              title: `${turnosInteresse[turno.nome]} ${val}`,
              classes: bgClass
            });
          }
        }
      }
      return events;
    }
  },
  methods: {
    async select (d) {
      this.dia = await d
      const dateKey = this.$formartData.removeTimeZone(d).split("T")[0];
      this.updateForcaSelecionada(dateKey);
      this.showModalForca = await "modalForca"
      this.reRenderModal = (await this.reRenderModal) + 1
    },

    async updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
      await this.fetchForcaMensal()
    },

    async onMonthYearSelected(data) {
      this.showDate = new Date(data.year, data.month, 1)
      await this.fetchForcaMensal()
    },

    async fetchForcaMensal() {
      let ano = this.showDate.getFullYear();
      let mes = this.showDate.getMonth() + 1;
      await this.$vs.loading({ container: `#${this.uniqueId}`, scale: 0.6 });
      try {
        this.mensalData = await this.$http.post("getForcaMensal", { ano, mes });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        };
      } finally {
        await this.$vs.loading.close(`#${this.uniqueId} > .con-vs-loading`);
      }
    },

    updateForcaSelecionada(dateKey) {
      if (this.mensalData && dateKey && this.mensalData[dateKey]) {
        this.forcaDataObjSelecionada = this.mensalData[dateKey];
      } else {
        this.forcaDataObjSelecionada = null;
      }
    },
  },
  async created () {
    this.$store.registerModule("calendar", moduleCalendar)
  },
  beforeDestroy () {
    this.$store.unregisterModule("calendar")
  },
  async mounted() {
    setTimeout(async () => {
      await this.fetchForcaMensal();
    }, 400);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
.cv-weeks {
  min-height: 26rem !important;
}
.cv-week {
  min-height: 6rem !important;
  overflow: hidden;
}
.theme-default .cv-day {
  overflow: hidden;
}
.theme-default .cv-day-number {
  max-width: 41.666% !important;
  min-width: unset !important;
  margin-left: 0.1rem !important;
  margin-right: 0.1rem !important;
  box-sizing: border-box !important;
}
.theme-default .cv-event {
  font-size: 0.6rem !important;
  border-radius: 0%;
  background-color: rgba(202, 202, 202, 0.233);
  color: black !important;
  
  /* Perfect 5:7 split math relative to .cv-week */
  width: 8.3333% !important; /* 7 parts */
  margin-left: 5.9523% !important; /* 5 parts */
  margin-right: 0 !important;
  min-width: unset !important;
  max-width: unset !important;
  box-sizing: border-box !important;
  pointer-events: none !important;
  
  line-height: 1.2;
}
.theme-default .cv-event.event-positive {
  background-color: #d4edda !important;
  color: #155724 !important;
  border-radius: 5px !important;
  margin-bottom: 2px !important;
  text-align: center;
  font-weight: bold;
  padding: 1px 0px !important;
}
.theme-default .cv-event.event-negative {
  background-color: #f8d7da !important;
  color: #721c24 !important;
  border-radius: 5px !important;
  margin-bottom: 2px !important;
  text-align: center;
  font-weight: bold;
  padding: 1px 0px !important;
}
.theme-default .cv-event.event-feriado {
  background-color: transparent !important;
  color: #c0392b !important;
  border-radius: 0 !important;
  font-weight: bold !important;
  font-size: 0.55rem !important;
  text-align: left;
  
  width: 8.3333% !important;
  margin-left: 5.9523% !important;
  margin-right: 0 !important;
  min-width: unset !important;
  max-width: unset !important;
  padding: 1px 0px !important;
  
  box-shadow: none !important;
  border: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
